export default __webpack_public_path__ + "static/media/pinknoise.a8f4b93e.ogg";